import React, { useEffect, useState } from "react";
import PaymentPageHeader from "../../Component/PaymentPageHeader/PaymentPageHeader.jsx";
import PaymentPageSidebar from "../../Component/PaymentPageSidebar/PaymentPageSidebar.jsx";
import Footer from "../../Component/Footer/Footer.jsx";
import TransactionReportService from "./TransactionReportService";
import { WALLET_TYPE } from "../../Constant.js";
import { RingLoader } from "react-spinners";
import { API_BASEURLICON } from "../../Config.js";

const TransactionReport = () => {
  const {
    getBalanceUser,
    balanceData,
    toggleSearch,
    showSearch,
    toDate,
    setToDate,
    fromDate,
    setFromDate,
    getRechargeReport,
    handleInputChange,
    searchInputs,
    transactionReportData,
    loading,
    itemsPerPage,
    currentPage,
    setCurrentPage,
    handlePrint,
    submitComplaint,
    actionDropdown,
    setActionDropdown,
    showReceiptPopup,
    setShowReceiptPopup,
    showComplaintPopup,
    setShowComplaintPopup,
    selectedTransaction,
    setSelectedTransaction,
  } = TransactionReportService();

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = transactionReportData?.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const totalPages = Math.ceil(transactionReportData?.length / itemsPerPage);

  useEffect(() => {
    getBalanceUser();
    getRechargeReport();
  }, []);

  return (
    <>
      <PaymentPageHeader />
      <div className="main-container">
        <div className="main-wrapper">
          <PaymentPageSidebar />
          <div className="main-content ">
            <div className="transactions-web-wrapper">
              <div className="header-section">
                <p className="transactions-heading">
                  Transactions &amp; Balances
                </p>
              </div>
              <div className="balances-segment">
                <div className="transaction-utility-wrapper ">
                  <div className="transaction-utility show-dropdown">
                    <img
                      className="utility-logo"
                      src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/transactionsHistory/wallet.svg"
                      alt="wallet-icon"
                    />
                    <div className="utility-wrapper">
                      {Object.keys(WALLET_TYPE)?.map((key) => {
                        if (!balanceData?.[key]) return null;

                        let balanceKey = "";
                        if (key === "isBalance") {
                          balanceKey = "balance";
                        } else if (key === "isBBalance") {
                          balanceKey = "bBalance";
                        } else if (key === "isCBalance") {
                          balanceKey = "cBalance";
                        } else if (key === "isUBalance") {
                          balanceKey = "uBalance";
                        } else if (key === "isIDBalance") {
                          balanceKey = "idBalnace";
                        } else if (key === "isPacakgeBalance") {
                          balanceKey = "pacakgeBalance";
                        }

                        const amount = balanceData?.[balanceKey] || 0;

                        return (
                          <div className="utility-upper-section" key={key}>
                            <div className="utility-heading-wrapper">
                              <div className="utility-heading dropdown">
                                <span className="utility-title">
                                  {WALLET_TYPE[key]}
                                </span>
                              </div>
                            </div>
                            <div className="utility-right-content">
                              <div className="content">
                                ₹{amount.toFixed(2)}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="transaction-utility show-dropdown  "></div>
                  <div className="transaction-utility   last-shown-element"></div>
                </div>
              </div>
              <div className="transactions-table-container">
                <div className="head-section">
                  <p className="payment-heading">Transaction History</p>
                  <div className="right-items">
                    <div className="tooltip-wrapper search-transaction-tooltip">
                      <span
                        className="tooltip-label"
                        onClick={toggleSearch}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/transactionsHistory/search-icon.svg"
                          alt="search"
                          className="search"
                        />
                      </span>
                    </div>
                  </div>
                </div>

                {showSearch && (
                  <div className="bill-payment-filter">
                    <div className="search-container">
                      <div className="search-wraper">
                        <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 gnaymJ"
                                placeholder="Transaction ID"
                                autoComplete="off"
                                name="transactionID"
                                value={searchInputs.transactionID}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        {/* <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 gnaymJ"
                                placeholder="TID"
                                autoComplete="off"
                                name="tid"
                                value={searchInputs.tid}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div> */}
                        <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 gnaymJ"
                                placeholder="Account No"
                                autoComplete="off"
                                name="accountNo"
                                value={searchInputs.accountNo}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <select
                                name="status"
                                value={searchInputs.status}
                                onChange={handleInputChange}
                              >
                                <option value="0">Status</option>
                                <option value="2">SUCCESS</option>
                                <option value="3">FAILED</option>
                                <option value="1">PENDING</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container cus-from-date">
                              
                              <input
                                type="date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                            
                              <input
                                type="date"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <button
                                type="button"
                                class="cus-kyc-btn btn-sm cus-kyc-btn-outline-secondary"
                                onClick={() => getRechargeReport()}
                              >
                                Search
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "400px",
                  }}
                >
                  <table className="transactions-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Action</th>
                        <th>TID</th>
                        <th>TransactionID</th>
                        <th>ReferenceID </th>
                        <th>Account</th>
                        <th>Operator</th>
                        <th>Req.Amount</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Refund Status</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="10">
                            <div className="loader">
                              <RingLoader color="#0077b6" size={50} />
                            </div>
                          </td>
                        </tr>
                      ) : currentData?.length > 0 ? (
                        currentData.map((item, index) => (
                          <tr className="transaction-item" key={index}>
                            <td>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td style={{ position: "relative" }}>
                              <button
                                className="action-btn"
                                onClick={() =>
                                  setActionDropdown(
                                    actionDropdown === index ? null : index,
                                  )
                                }
                              >
                                ▾
                              </button>

                              {actionDropdown === index && (
                                <div className="action-dropdown">
                                  {" "}
                                  {item?.type_ === "SUCCESS" && (
                                    <>
                                      {" "}
                                      <div
                                        className="dropdown-item"
                                        onClick={() => {
                                          setSelectedTransaction(item);
                                          setShowReceiptPopup(true);
                                          setActionDropdown(null);
                                        }}
                                      >
                                        Transaction Receipt
                                      </div>
                                      <div
                                        className="dropdown-item"
                                        onClick={() => {
                                          setSelectedTransaction(item);
                                          setShowComplaintPopup(true);
                                          setActionDropdown(null);
                                        }}
                                      >
                                        Complaint
                                      </div>
                                    </>
                                  )}
                                </div>
                              )}
                            </td>
                            <td>{item?.tid || "N/A"}</td>
                            <td>{item?.transactionID || "N/A"}</td>
                            <td>{item?.liveID || "N/A"}</td>
                            <td>{item?.account || "N/A"}</td>
                            <td>{item?.operator || "N/A"}</td>
                            <td>{item?.requestedAmount || "N/A"}</td>
                            <td>{item?.amount || "N/A"}</td>
                            <td>
                              <span
                                className={`status-badge ${
                                  item?.type_ === "SUCCESS"
                                    ? "status-success"
                                    : item?.type_ === "FAILED"
                                      ? "status-failed"
                                      : item?.type_ === "PENDING"
                                        ? "status-pending"
                                        : ""
                                }`}
                              >
                                {item?.type_ || "N/A"}
                              </span>
                            </td>
                            <td>
                              <span className="refund-badge">
                                {item?.refundStatus_ || "N/A"}
                              </span>
                            </td>
                            <td>{item?.entryDate || "N/A"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" style={{ textAlign: "center" }}>
                            !!! &#128528; &#128528; No Data found &#128528;
                            &#128528;!!!
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="pagination-buttons">
                  <ul class="pagination">
                    <li class="page-item">
                      <button
                        onClick={() =>
                          setCurrentPage((p) => Math.max(1, p - 1))
                        }
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                    </li>
                    <li class="page-item">
                      <div>
                        {currentPage} of {totalPages}
                      </div>
                    </li>
                    <li class="page-item">
                      <button
                        onClick={() =>
                          setCurrentPage((p) => Math.min(totalPages, p + 1))
                        }
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showReceiptPopup && (
        <div className="bbps-popup-overlay">
          <div class="bbps-wrapper">
            <button
              className="bbps-close"
              onClick={() => setShowReceiptPopup(false)}
            >
              ✕
            </button>
            <div class="bbps-header">
              <div class="bbps-left">
                <img src={`${API_BASEURLICON}/Image/Website/1/favicon.png`} />
              </div>

              <div class="bbps-right">
                <img src={`${API_BASEURLICON}/images/bassured.png`} />
                <img
                  src={`${API_BASEURLICON}/images/bbps.png`}
                  class="bbps-bbps"
                />
              </div>
            </div>
            <h2 class="bbps-title">Transaction Detail</h2>
            <div class="bbps-table">
              <div class="bbps-row">
                <div class="bbps-label">Transaction Status</div>
                <div class="bbps-colon">:</div>
                <div class="bbps-value success">
                  {selectedTransaction?.type_}
                </div>
              </div>

              <div class="bbps-row">
                <div class="bbps-label"> Transaction ID</div>
                <div class="bbps-colon">:</div>
                <div class="bbps-value">{selectedTransaction?.tid}</div>
              </div>

              <div class="bbps-row">
                <div class="bbps-label">Provider Name</div>
                <div class="bbps-colon">:</div>
                <div class="bbps-value">{selectedTransaction?.operator}</div>
              </div>

              <div class="bbps-row">
                <div class="bbps-label">Mobile Number</div>
                <div class="bbps-colon">:</div>
                <div class="bbps-value">{selectedTransaction?.account}</div>
              </div>

              <div class="bbps-row">
                <div class="bbps-label">Bill/Recharge Amount</div>
                <div class="bbps-colon">:</div>
                <div class="bbps-value"> {selectedTransaction?.amount}</div>
              </div>
              <div class="bbps-row">
                <div class="bbps-label">Convenience Fee inclusive of GST</div>
                <div class="bbps-colon">:</div>
                <div class="bbps-value"> 0.00</div>
              </div>

              <div class="bbps-row">
                <div class="bbps-label">Bharat Connect Transaction ID</div>
                <div class="bbps-colon">:</div>
                <div class="bbps-value">
                  {selectedTransaction?.transactionID}
                </div>
              </div>
              <div class="bbps-row">
                <div class="bbps-label">Date & Time</div>
                <div class="bbps-colon">:</div>
                <div class="bbps-value">{selectedTransaction?.entryDate}</div>
              </div>
            </div>
            <p class="bbps-note">
              Your payment will be updated at billers end within 3 to 5 working
              days.
            </p>
            <p class="bbps-warning">
              Please note this is not a GST invoice but only a confirmation
              receipt for the amount paid.
            </p>
            <div class="bbps-footer">
              <p>
                This is a system generated receipt and does not require any
                signature.
              </p>
            </div>
            <div class="print-button">
              <button onClick={handlePrint}>Print</button>
            </div>
          </div>
        </div>
      )}

      {showComplaintPopup && (
        <div className="complaint-overlay">
          <div className="complaint-modal">
            <div className="complaint-header">
              <h3>Raise Complaint</h3>
              <button
                className="close-btn-complain"
                onClick={() => setShowComplaintPopup(false)}
              >
                ✕
              </button>
            </div>

            <div className="complaint-body">
              <p>
                Are you sure you want to raise a complaint for this transaction?
              </p>
            </div>

            <div className="complaint-actions">
              <button className="btn-submit" onClick={submitComplaint}>
                Yes, Submit
              </button>
              <button
                className="close-btn-complain-1"
                onClick={() => setShowComplaintPopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default TransactionReport;
